import React from "react";
import DateRangePicker from "@mui/lab/DateRangePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Box from "@mui/material/Box";
import { LabelText } from "../styled/DatePicker.styled";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Text } from "../styled/DatePicker.styled";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { InputAdornment } from '@mui/material';

export default function DatePicker({ dateRange, setDateRange }) {
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <LabelText>Date Range</LabelText>
        <DateRangePicker
          value={dateRange}
          onChange={(newValue) => {
            setDateRange(newValue);
          }}
          renderInput={(startProps, endProps) => (
            <React.Fragment>
              <OutlinedInput
                sx={{
                  fontSize: "13px",
                  color: "#707070",
                  height: "40px",
                }}
                notched={false}
                {...startProps}
                endAdornment={
                  dateRange[0] && (
                    <InputAdornment position="end">
                      <IconButton style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "7px",
                        color: "rgba(0,0,0,0.54)"
                      }} edge="end" onClick={() => setDateRange([null, dateRange[1]])}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  )
                }
              />
              <Box sx={{ mx: 2 }}>
                {" "}
                <Text>to</Text>{" "}
              </Box>
              <OutlinedInput
                sx={{
                  fontSize: "13px",
                  color: "#707070",
                  height: "40px",
                }}
                notched={false}
                {...endProps}
                endAdornment={
                  dateRange[1] && (
                    <InputAdornment position="end">
                      <IconButton style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "7px",
                        color: "rgba(0,0,0,0.54)"
                      }} edge="end" onClick={() => setDateRange([dateRange[0], null])}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  )
                }
              />
            </React.Fragment>
          )}
        />
      </LocalizationProvider>
    </div>
  );
}
